import BossModel from "@/models/BossModel";
import Margin from "@/models/Margin/Margin";
import Agent from "@/models/Agent/Agent";
import Type from "@/models/Product/Type/Type";

export default class Inventory extends BossModel {

    static apiUrl = 'agent/inventory';

    static entity = 'agentInventories';

    static fields() {
        return {
            id: this.number(null).nullable(),
            agent_eid: this.string(),
            name: this.string(null),
            agent_id: this.number(),
            margin_id: this.number(null).nullable(),
            product_type_id: this.number(null),
            agent: this.belongsTo(Agent, 'agent_id'),
            margin: this.belongsTo(Margin, 'margin_id'),
            productType: this.belongsTo(Type, 'product_type_id'),
        }
    }
}
